import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import GuidePage from "../pages/guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/shopping-guide",
    element: <GuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;